// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2IXU3","title":"AfterBackImages_title__1pIjD","images":"AfterBackImages_images__2_rqi"};